import { useCallback, useEffect, useState } from 'react';
import {
  ASSOCIACAO_PREMIACAO_MAX_RECORDS,
  ASSOCIACAO_PREMIACAO_PAGE_SIZE,
  getPremiacaoTabelaVeiculos,
  getPremiacaoTabelas,
  getVeiculosPropriosPremiacao
} from '@spark/services/premiacao';
import { notification } from '@spark/ui-components/utils/notification';
import { fetchPremiacaoPaginatedList } from '../utils/fetchPremiacaoPaginatedList';

const pick = (data, ...keys) => {
  for (let index = 0; index < keys.length; index += 1) {
    const key = keys[index];
    if (data?.[key] !== undefined && data?.[key] !== null) {
      return data[key];
    }
  }
  return undefined;
};

const mapVeiculo = (item) => {
  const nomesTabelasPremiacao = pick(item, 'nomesTabelasPremiacao', 'NomesTabelasPremiacao') || '';
  return {
    id: pick(item, 'numeroFrota', 'NumeroFrota') || '',
    numeroFrota: pick(item, 'numeroFrota', 'NumeroFrota') || '',
    placa: pick(item, 'placa', 'Placa') || '',
    segmento: pick(item, 'segmento', 'Segmento') || '',
    modelo: pick(item, 'modelo', 'Modelo') || '',
    motorista: pick(item, 'motorista', 'Motorista') || '',
    nomesTabelasPremiacao,
    gestor: pick(item, 'gestor', 'Gestor') || '',
    temVinculo: String(nomesTabelasPremiacao).trim().length > 0
  };
};

const mapTabela = (item, tabelasComVinculo) => {
  const id = pick(item, 'id', 'Id');
  return {
    id,
    nome: pick(item, 'nome', 'Nome') || '',
    segmento: pick(item, 'segmento', 'Segmento') || '',
    temVinculo: tabelasComVinculo.has(Number(id))
  };
};

const buildTabelasComVinculo = (vinculos) => {
  const ids = new Set();
  vinculos.forEach((item) => {
    const idTabela = pick(item, 'idTabelaPremiacao', 'IdTabelaPremiacao');
    if (idTabela !== undefined && idTabela !== null) {
      ids.add(Number(idTabela));
    }
  });
  return ids;
};

export const usePremiacaoAssociacaoData = (show) => {
  const [veiculos, setVeiculos] = useState([]);
  const [tabelas, setTabelas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [veiculosTruncados, setVeiculosTruncados] = useState(false);
  const [tabelasTruncadas, setTabelasTruncadas] = useState(false);

  const carregarDados = useCallback(async () => {
    if (!show) {
      return;
    }

    try {
      setLoading(true);
      const paginationConfig = {
        pageSize: ASSOCIACAO_PREMIACAO_PAGE_SIZE,
        maxRecords: ASSOCIACAO_PREMIACAO_MAX_RECORDS
      };

      const [veiculosResult, tabelasResult, vinculosResult] = await Promise.all([
        fetchPremiacaoPaginatedList({
          fetchPage: getVeiculosPropriosPremiacao,
          baseFilters: {},
          ...paginationConfig
        }),
        fetchPremiacaoPaginatedList({
          fetchPage: getPremiacaoTabelas,
          baseFilters: { Ativo: true },
          ...paginationConfig
        }),
        fetchPremiacaoPaginatedList({
          fetchPage: getPremiacaoTabelaVeiculos,
          baseFilters: { Ativo: true },
          ...paginationConfig
        })
      ]);

      const tabelasComVinculo = buildTabelasComVinculo(vinculosResult.registros);

      setVeiculos(veiculosResult.registros.map(mapVeiculo));
      setTabelas(tabelasResult.registros.map((item) => mapTabela(item, tabelasComVinculo)));
      setVeiculosTruncados(veiculosResult.truncado);
      setTabelasTruncadas(tabelasResult.truncado);
    } catch (error) {
      console.error('Erro ao carregar dados de associacao:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar dados de associacao',
        'Erro ao carregar'
      );
      setVeiculos([]);
      setTabelas([]);
      setVeiculosTruncados(false);
      setTabelasTruncadas(false);
    } finally {
      setLoading(false);
    }
  }, [show]);

  useEffect(() => {
    if (!show) {
      setVeiculos([]);
      setTabelas([]);
      setVeiculosTruncados(false);
      setTabelasTruncadas(false);
      return;
    }
    carregarDados();
  }, [show, carregarDados]);

  return {
    veiculos,
    tabelas,
    loading,
    veiculosTruncados,
    tabelasTruncadas,
    reload: carregarDados
  };
};
